export default "__VITE_ASSET__DYwePW5e__"